import { TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import ScreenShot from "./ScreenShot";
import QrList from "./QrList";
import Searched from "./Searched";
import ShoppingList from "./ShoppingList";
import GetConfig from "./GetConfig";
import configData from "../../config.json";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth"

function RealTimeRow({ row, config, hasToken, handleNewToken }) {
  const navigate = useNavigate();
  const [deviceConfig, setDeviceConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(false);
  const [configStatus, setConfigStatus] = useState("N/A");
  // useEffect(() => {
  //   console.log(row);
  //   if (row.config) {
  //     console.log(row.config, "this is raw config");

  //     // setDeviceConfig(row.config);
  //   }
  // }, [config, row]);
  const getDeviceConfig = (device_id) => {
    setConfigLoading(true);
    setDeviceConfig(null);
    setConfigStatus("N/A");
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(`${configData.SERVER_URL}/DeviceConfig/${device_id}`, {
      headers,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.res === "Success") {
          setConfigStatus(data.res);
          setConfigLoading(false);
        } else {
          console.log(data.res);
          setConfigStatus(data.res);
          setConfigLoading(false);
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          handleNewToken(false);
        } else {
          if (error.message === "403") {
            handleNewToken(false);
          } else {
            console.log(error);
          }
        }
      });
  };
  return (
    <TableRow
      key={row.serial_number}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        {row.serial_number}
      </TableCell>
      <TableCell align="left">
        <ScreenShot
          device_id={row.device_id}
          multi={true}
          handleNewToken={handleNewToken}
        />
      </TableCell>
      <TableCell align="left">
        <ShoppingList shoppingList={row.shopping_list} />
      </TableCell>
      <TableCell align="left">
        <Searched searched={row.searched} />
      </TableCell>
      <TableCell align="left">
        <QrList qrList={row.qr_list} />
      </TableCell>
      <TableCell align="left">
        <GetConfig
          device_id={row.device_id}
          serial_number={row.serial_number}
          deviceConfig={row.config}
          configLoading={configLoading}
          configStatus={configStatus}
          getDeviceConfig={getDeviceConfig}
        />
      </TableCell>
    </TableRow>
  );
}

export default RealTimeRow;
